import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=981be8c6&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('981be8c6')) {
      api.createRecord('981be8c6', component.options)
    } else {
      api.reload('981be8c6', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=981be8c6&", function () {
      api.rerender('981be8c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2vqjkmH0qoVCu/JS/comp/openstreetmap.vue"
export default component.exports